module.exports = __webpack_public_path__ + "static/media/divinity2.3cccc3d4.jpg";